module.exports = __webpack_public_path__ + "img/ff51a05.jpg";